var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoW(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 237 219",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M99.5676 201.532C95.0583 187.988 95.7463 185.435 110.457 188.116C125.168 190.799 124.922 193.438 115.917 204.506C107.006 215.487 104.033 214.947 99.5676 201.532Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M75.7858 216.284C53.0845 211.128 50.1112 207.992 66.2818 189.748C82.4565 171.488 85.9245 174.066 93.7712 195.973C101.547 217.7 98.2885 221.378 75.7858 216.284Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.1913 68.9815C45.4993 67.7082 27.5207 70.3775 13.7273 76.9175L10.1993 78.5975C4.91133 90.3988 1.63933 102.973 0.467326 115.98C-2.04867 143.961 5.67666 171.176 21.6593 190.641C27.802 198.12 32.742 201.608 37.2007 201.608C37.222 201.608 37.2433 201.608 37.2647 201.607C41.6393 201.575 46.3953 198.151 52.23 190.828C68.2153 169.68 92.67 127.932 76.6127 86.2202C75.3473 82.9335 72.0087 76.8268 67.1913 68.9815Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M191.734 137.552C211.933 131.419 226.081 121.067 232.647 107.615C238.633 95.3573 238.422 80.7159 232.021 64.0946C227.631 52.6893 221.093 42.3573 212.586 33.3866C181.381 0.49595 128.195 -9.19872 80.2367 9.25861C75.0447 11.2586 69.9473 13.6386 65.0913 16.3333C63.6273 17.1466 62.178 17.9893 60.75 18.8639C94.866 1.15062 134.451 -0.33738 165.578 16.3226C176.162 21.9906 185.349 29.5253 192.883 38.7146C205.889 54.5426 211.219 72.7666 207.894 90.0266C203.655 112 186.37 129.807 160.47 138.887L160.017 139.012C169.175 141.657 179.822 141.173 191.734 137.552Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.6299 38.3736C52.9605 45.7576 62.6179 54.1722 70.0965 64.0442C87.7752 66.0042 118.298 73.8789 128.766 104.379C133.991 119.572 141.873 130.146 152.193 135.81C191.869 124.74 200.809 99.4349 202.814 89.0482C205.842 73.3242 200.895 56.6149 188.883 41.9989C181.785 33.3362 173.121 26.2336 163.134 20.8842C133.165 4.84158 93.6832 6.44824 60.0899 25.0829C53.3952 28.7962 46.9779 33.1602 41.0192 38.0509C40.8885 38.1576 40.7592 38.2656 40.6299 38.3736Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M89.5909 151.284C100.299 144.638 112.046 140.996 125.504 140.15C132.33 139.729 138.94 138.84 145.203 137.505C135.93 130.833 128.762 120.272 123.874 106.06C115.015 80.2437 89.7389 72.213 73.7002 69.7383C76.6789 74.7317 80.0082 80.6383 81.4402 84.361C92.4575 112.981 85.2469 141.392 75.5295 162.365C80.0002 157.982 84.5269 154.429 89.5895 151.284H89.5909Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.5412 41.9673C27.1265 50.7486 19.6665 60.3473 13.8398 71.1899C27.0945 65.4673 43.6332 62.9219 63.1198 63.6086C56.1758 55.4179 47.4452 48.3139 36.5412 41.9673Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoW);
export default __webpack_public_path__ + "static/media/logo_w.0f890a32d462be8f9bc91b201aaed923.svg";
export { ForwardRef as ReactComponent };